import * as React from "react";
import ReactDOM from "react-dom";
import { GoogleReviews, RetailerMapSimple } from "./";
import Loader from "../Loader";
import { getParameterByName } from "../../utils/dom";
import { Dealer, GoogleReview } from "../../models";
import { ApiBasePath } from "../../utils/ApiBasePath";
import * as Request from "superagent";
import { ServicesList } from "./";
import classNames from "classnames";
import TagManager from "react-gtm-module";

interface Props {
  match: any;
}

interface State {
  dealer: Dealer;
  error: string;
  isFetching: boolean;
  isFetchingReviews: boolean;
  activeTab: number;
  reviews: GoogleReview[];
  ratingValue: number;
}

class RetailerDetails extends React.Component<Props, State> {
  map: google.maps.Map;
  constructor(props) {
    super(props);
    this.state = {
      dealer: null,
      error: "",
      isFetching: false,
      isFetchingReviews: false,
      activeTab: 0,
      reviews: [],
      ratingValue: 5,
    };
    this.loadDealer = this.loadDealer.bind(this);
    this.fetchReviews = this.fetchReviews.bind(this);
  }

  componentDidMount() {
    this.loadDealer();
    window["pushDigitalData"]({
      event: "_pageLoaded",
    });
  }

  loadDealer() {
    this.setState({
      isFetching: true,
    });
    //const uniqueName = window.location.pathname.split("/").pop();
    // console.log(this.props.match.params.dealerUniqueName);
    const uniqueName = this.props.match.params.dealerUniqueName;
    const url = `${ApiBasePath.dealers}/DealerByUniqueName/${uniqueName}`;

    Request.get(url).then(
      (response) => {
        const dealer = response.body;
        this.setState(
          {
            dealer,
            error: "",
            isFetching: false,
          },
          function () {
            if (dealer && dealer.dealerDetails.length) {
              const dealerDetails = dealer.dealerDetails[0];
              // console.log(dealer.dealerDetails);
              TagManager.dataLayer({
                dataLayer: {
                  dealer_phone: dealerDetails.phone,
                  event: "dealer_phone",
                },
              });
              TagManager.dataLayer({
                dataLayer: {
                  dealer_address:
                    dealerDetails.address +
                    " " +
                    dealerDetails.suburb +
                    ", " +
                    dealer.state +
                    " " +
                    dealerDetails.postCode,
                  event: "dealer_address",
                },
              });
              this.gtmPushTradingHours(dealerDetails);
              TagManager.dataLayer({
                dataLayer: {
                  event_id: "dealer_full_details_pageview",
                  event: "sd-pageview",
                },
              });
            }
            this.fetchReviews(this.state.dealer.dealerDetails[0].googlePlaceId);
          }
        );
      },
      (error) => {
        console.error(error);
        this.setState({
          dealer: null,
          error: "Sorry cannot find dealer.",
          isFetching: false,
        });
      }
    );
  }

  fetchReviews(googlePlaceId) {
    if (!!googlePlaceId) {
      this.setState({
        isFetchingReviews: true,
        reviews: [],
      });

      const mapRef = this.refs.map;
      const node = ReactDOM.findDOMNode(mapRef);
      this.map = new google.maps.Map(node);
      var service = new google.maps.places.PlacesService(this.map);
      service.getDetails(
        {
          placeId: googlePlaceId,
        },
        function (place, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            !!place.reviews &&
              this.setState({
                reviews: place.reviews,
                isFetchingReviews: false,
              });
            !!place.rating &&
              this.setState({
                ratingValue: place.rating,
                isFetchingReviews: false,
              });
            TagManager.dataLayer({
              dataLayer: {
                total_review_items: place.reviews ? place.reviews.length : 0,
                event: "total_review_items",
              },
            });
            TagManager.dataLayer({
              dataLayer: {
                rating_average: place.rating || 0,
                event: "rating_average",
              },
            });
          } else {
            this.setState({
              reviews: [],
              ratingValue: 5,
              isFetchingReviews: false,
            });
          }
        }.bind(this)
      );
    } else {
      this.setState({
        reviews: [],
        isFetchingReviews: false,
      });
    }
  }

  gtmPushTradingHours(dealerDetail) {
    TagManager.dataLayer({
      dataLayer: {
        trading_weekday: `${dealerDetail.monFriOpen}-${dealerDetail.monFriClose}`,
        event: "trading_weekday",
      },
    });
    TagManager.dataLayer({
      dataLayer: {
        trading_sat: `${dealerDetail.satOpen}-${dealerDetail.satClose}`,
        event: "trading_sat",
      },
    });
    TagManager.dataLayer({
      dataLayer: {
        trading_sun: `${dealerDetail.sunOpen}-${dealerDetail.sunClose}`,
        event: "trading_sun",
      },
    });
  }

  handleClick = (index) => {
    let oldGooglePlaceId =
      this.state.dealer.dealerDetails[this.state.activeTab].googlePlaceId;
    this.setState(
      {
        activeTab: index,
      },
      function () {
        const googlePlaceId =
          this.state.dealer.dealerDetails[index].googlePlaceId;
        if (googlePlaceId !== oldGooglePlaceId) {
          this.fetchReviews(
            this.state.dealer.dealerDetails[index].googlePlaceId
          );
        }

        this.gtmPushTradingHours(this.state.dealer.dealerDetails[index]);
      }
    );
  };

  render() {
    const { error, dealer, isFetching, activeTab, ratingValue, reviews } =
      this.state;

    const { dealerDetails } = !!dealer && dealer;
    return (
      <div className={`find-dealer-detail ${!!dealer ? "" : "is-loading"}`}>
        {!!dealer && (
          <div>
            <div className="find-dealer-detail__hero no-image">
              <h1>{dealer.name}</h1>
            </div>
            <div className="fake-dealers-map" ref="map" />
            <div className="container">
              {dealerDetails.length > 0 && (
                <div className="tabs">
                  {!!dealerDetails
                    ? dealerDetails.map((department, index) => {
                        const { departmentName } = department;
                        const tabsClass = classNames({
                          "tab with-ico": true,
                          "is-active": index === activeTab,
                        });

                        const svgIcon = classNames({
                          "icon-parts":
                            departmentName === "Parts and Accessories",
                          "icon-sales":
                            departmentName === "Vehicle Sales" ||
                            departmentName === "WRX STI Vehicle Sales" ||
                            departmentName === "Electric",
                          "icon-service": departmentName === "Service",
                          "icon-collision":
                            departmentName === "Certified Collision Repairers",
                          "icon-motorsport":
                            departmentName === "Motorsport Parts",
                        });

                        return (
                          <div key={departmentName} className={tabsClass}>
                            <button
                              onClick={this.handleClick.bind(this, index)}
                            >
                              <span>
                                <em>
                                  <svg className="svg-icon">
                                    <use xlinkHref={`#${svgIcon}`} />
                                  </svg>
                                  {department.departmentName}
                                </em>
                              </span>
                            </button>
                          </div>
                        );
                      })
                    : null}
                </div>
              )}
            </div>
            <RetailerMapSimple
              dealer={dealer}
              dealerDetails={dealerDetails[activeTab]}
            />
            <div className="find-dealer-detail__content container">
              <div className="row">
                <div className="col col-sm-7">
                  <h2>Google Reviews</h2>

                  {!!reviews ? (
                    <div>
                      {reviews.length > 0 ? (
                        <GoogleReviews
                          ratingValue={ratingValue}
                          reviews={reviews}
                        />
                      ) : (
                        <p>
                          This dealer doesn't have any reviews.
                          <br />
                        </p>
                      )}
                    </div>
                  ) : (
                    <p>
                      Dealer reviews are not available. <br />
                    </p>
                  )}
                </div>
                <div className="col col-sm-4 col-offset-1">
                  {dealerDetails[activeTab].serviceList.length > 0 && (
                    <div>
                      <h2>Available Services</h2>

                      <ServicesList
                        serviceList={dealerDetails[activeTab].serviceList}
                        departmentName={dealerDetails[activeTab].departmentName}
                      />
                    </div>
                  )}
                  {dealerDetails[activeTab].departmentName ===
                    "Certified Collision Repairers" && (
                    <p>
                      Find out more about{" "}
                      <a href="/certified-collision-repairers" target="_blank">
                        certified collision repairers
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {error !== "" && (
          <p className="no-result">
            {`${error}`} <br />
            <a href="/dealers">View all dealers</a>
          </p>
        )}
        {isFetching && <Loader isLoading={true} />}
      </div>
    );
  }
}

export default RetailerDetails;
